import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { type InboxActions, InternalInboxActions } from '../actions'
import { inboxClient } from '../client'
import type { InboxPage } from '../types'

export function* fetchEarlier({
  payload: { workspace, before },
}: ReturnType<typeof InboxActions.fetchEarlier>) {
  yield put(InternalInboxActions.earlierLoading({ workspace }))

  try {
    const page: InboxPage = yield call(inboxClient.earlier, workspace, before)

    yield put(
      InternalInboxActions.earlierLoaded({
        workspace,
        page,
        append: before !== null,
      })
    )
  } catch (error) {
    console.error('Error fetching activity:', error)

    yield put(InternalInboxActions.earlierFailed({ workspace }))
    yield put(GeneralErrorNotification)
  }
}
